import React from "react";

// Coquille d'une carte rendez-vous : icône calendrier, en-tête
// (date, pastilles, actions) et corps.
const RdvItemContainer = ({ header, children }) => (
  <article className="rdv-card">
    <header className="rdv-card__head">
      <span className="rdv-card__icon" aria-hidden="true">
        <i className="fa fa-calendar-alt" />
      </span>
      {header}
    </header>
    {children}
  </article>
);

export default RdvItemContainer;
